var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-v4-Item-Expanded",
    transform: "translate(-285.000000, -81.000000)",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(286.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.18181818,7.99992649 L18.1818182,8.00007351",
    id: "Line",
    transform: "translate(8.000000, 8.000000) rotate(45.000000) translate(-8.000000, -8.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.18181818,8.00008633 L18.1818182,7.99991367",
    id: "Line",
    transform: "translate(8.000000, 8.000000) rotate(-45.000000) translate(-8.000000, -8.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIcon);
export default __webpack_public_path__ + "static/media/ModalIcon.1e585a4c83b1f4e6412c258fcf95585b.svg";
export { ForwardRef as ReactComponent };